export const getMoreLessButtonId = (isMoreShown: boolean): string => {
    return isMoreShown ? "plp-horizontal-filter-more-button" : "plp-horizontal-filter-less-button"
}
